import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hire-android-app-dev',
  templateUrl: './hire-android-app-dev.component.html',
  styleUrls: ['./hire-android-app-dev.component.css']
})
export class HireAndroidAppDevComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/hire-android-app-dev/hire-android-app-dev.component.ts